import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { takeUntil } from 'rxjs/operators';
import { IDataGridElement } from 'shared';
import { TakeUntilDestroy } from 'src/app/core/decorators';
import { GeneralService } from 'src/app/core/services';
import { APP_STATE_TOKEN } from 'src/app/core/store/app.store.state';

@Component({
  selector: 'app-modal-locales-universidad',
  templateUrl: './modal-locales-universidad.component.html',
  styleUrls: ['./modal-locales-universidad.component.scss']
})
@TakeUntilDestroy
export class ModalLocalesUniversidadComponent implements OnInit, OnDestroy {

  gridLocales: IDataGridElement<any> = {
    loading: false,
    definition: {
      columns: [
        { label: 'Nombre del local', field: 'tpl-nombreLocal', template: 'tpl-nombreLocal' },
        { label: 'Modalidades de estudio', field: 'modalidadEstudio' },
        { label: 'Distancia', field: 'tpl-distancia', template: 'tpl-distancia', hidden: false }
      ]
    },
    source: {
      items: [],
      page: 1,
      pageSize: 10,
      total: 0
    }
  };

  private unsubscribe: any;

  constructor(
    private store: Store,
    private generalService: GeneralService,
    public dialogRef: MatDialogRef<ModalLocalesUniversidadComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { idEntidad, idPrograma, idProgramaDocumento }
  ) { }

  ngOnInit() {
    this.listarLocalesEntidad();
    this.store.select(s => s.appState.globalConfig.userGeoLocation)
      .pipe(takeUntil(this.unsubscribe())).subscribe((value) => {

        const column = this.gridLocales.definition.columns.find(x => x.field == 'tpl-distancia');
        column.hidden = value ? false : true;

        this.listarLocalesEntidad();
      });
  }

  ngOnDestroy() { }

  handleClose = () => {
    this.dialogRef.close();
  }

  handleAceptar = () => {
    this.dialogRef.close();
  }

  private listarLocalesEntidad = () => {
    const { globalConfig: { userGeoLocation } } = this.store.selectSnapshot(APP_STATE_TOKEN);

    const obs = (this.data.idPrograma ?
      this.generalService.getLocalesEntidadPrograma(
        this.data.idEntidad,
        this.data.idPrograma,
        this.data.idProgramaDocumento??0,
        userGeoLocation ? userGeoLocation.position : null
      ) :
      this.generalService.getLocalesEntidad(
        this.data.idEntidad,
        userGeoLocation ? userGeoLocation.position : null
      )
    );

    obs.subscribe((response) => {
      this.gridLocales.source = {
        ...this.gridLocales.source,
        items: [
          ...response.data
        ]
      }
    });
  }

}
